import React from 'react'
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
	Row,
	Col
} from 'reactstrap'
import FontAwesome from 'react-fontawesome'


export default class ModalConfirm extends React.Component {
	render() {
		return (
			<React.Fragment>
				<Modal
					isOpen={this.props.show === true}
				>
					<ModalHeader>
						<FontAwesome name="exclamation-circle" />
						{' '}
						Please Confirm
					</ModalHeader>
					<ModalBody>
						{this.props.message}
					</ModalBody>
					<ModalFooter>
						<div>
							<Row>
								<Col sm={6}>
									<Button
										onClick={this.props.handleConfirm}
										color="success"
										block
									>
										<FontAwesome name="thumbs-up" />
										{' '}
										Confirm
									</Button>
								</Col>
								<Col sm={6}>
									<Button
										onClick={this.props.handleCancel}
										color="danger"
										block
									>
										<FontAwesome name="thumbs-down" />
										{' '}
										Cancel
									</Button>
								</Col>
							</Row>
						</div>
					</ModalFooter>
				</Modal>
			</React.Fragment>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/_shared/modalConfirm.jsx